import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { TableRowElement } from '@website-builder/widgets/table/table-row-element';
import { TableStyle } from '@website-builder/widgets/table/model/table-style';
import { TableTextStyle } from '@website-builder/widgets/table/model/table-text-style';
import { TableImageStyle } from '@website-builder/widgets/table/model/table-image-style';
import { TableIconStyle } from '@website-builder/widgets/table/model/table-icon-style';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class TableWidget extends BaseMultipleWidget<TableRowElement, TableStyle> {
  readonly type = BuilderElementType.Table;
  style = new TableStyle();
  textStyle = new TableTextStyle();
  imageStyle = new TableImageStyle();
  iconStyle = new TableIconStyle();
  buttonStyle = new GlobalButtonStyle();

  columns = [
    { id: makeEntityId(EntityIdPrefix.COLUMN), name: 'title' },
    {
      id: makeEntityId(EntityIdPrefix.COLUMN),
      name: 'name',
    },
    { id: makeEntityId(EntityIdPrefix.COLUMN), name: 'activity' },
  ];

  elements = [
    new TableRowElement(3),
    new TableRowElement(3),
    new TableRowElement(3),
    new TableRowElement(3),
    new TableRowElement(3),
  ];
  hideTableHead: boolean;

  static normalizeInPlace(widget: TableWidget): TableWidget {
    const pureWidget = new TableWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.columns = widget.columns ?? pureWidget.columns;
    widget.elements = (widget.elements ?? pureWidget.elements).map(element => TableRowElement.normalizeInPlace(element));
    widget.hideTableHead = widget.hideTableHead ?? pureWidget.hideTableHead;

    widget.style = TableStyle.normalize(widget.style);
    widget.textStyle = TableTextStyle.normalize(widget.textStyle);
    widget.imageStyle = TableImageStyle.normalize(widget.imageStyle);
    widget.iconStyle = TableIconStyle.normalize(widget.iconStyle);
    widget.buttonStyle = GlobalButtonStyle.normalize(widget.buttonStyle);

    return widget;
  }
}
